"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Permissions_1 = require("../permissions/Permissions");
/**
 * Will be only used for multiple permissions
 */
var PermissionsGroup = /** @class */ (function () {
    function PermissionsGroup() {
    }
    PermissionsGroup.verifyObjectReadFileDownload = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
    };
    PermissionsGroup.verifyObjectReadTypeDefReadFileDownload = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
    };
    PermissionsGroup.verifyObjectReadTypeDefRead = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
    };
    PermissionsGroup.verifyTypeDefReadWrite = function () {
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
    };
    PermissionsGroup.verifyTypeDefReadCreate = function () {
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefCreatePermission();
    };
    PermissionsGroup.verifyTypeDefReadDelete = function () {
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefDeletePermission();
    };
    PermissionsGroup.verifyObjectReadFileDownloadSearch = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
    };
    PermissionsGroup.verifyObjectReadWriteDeleteFileUploadDownloadSearch = function () {
        Permissions_1.rbacPermissions.verifyObjectDeletePermission();
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
    };
    PermissionsGroup.verifyObjectCreateReadWriteFileUploadDownloadSearch = function () {
        Permissions_1.rbacPermissions.verifyObjectCreatePermission();
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
    };
    PermissionsGroup.verifyObjectreadWriteFileUploadDownloadSearch = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
    };
    PermissionsGroup.verifyObjectCreateReadWriteTypeDefCreateReadWrite = function () {
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefCreatePermission();
        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
        Permissions_1.rbacPermissions.verifyObjectCreatePermission();
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
    };
    PermissionsGroup.verifyObjectCreateReadWriteTypeDefCreateReadWriteFileUploadDownloadSearch = function () {
        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
        Permissions_1.rbacPermissions.verifyTypeDefCreatePermission();
        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
        Permissions_1.rbacPermissions.verifyObjectCreatePermission();
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
    };
    PermissionsGroup.verifyObjectCreateReadWriteDeleteFileUploadDownloadSearchDelete = function () {
        Permissions_1.rbacPermissions.verifyObjectCreatePermission();
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyObjectDeletePermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
        Permissions_1.rbacPermissions.verifyFileDeletePermission();
    };
    PermissionsGroup.verifyObjectReadWriteDeleteFileUploadDownloadSearchDelete = function () {
        Permissions_1.rbacPermissions.verifyObjectReadPermission();
        Permissions_1.rbacPermissions.verifyObjectWritePermission();
        Permissions_1.rbacPermissions.verifyObjectDeletePermission();
        Permissions_1.rbacPermissions.verifyFileUploadPermission();
        Permissions_1.rbacPermissions.verifyFileDownloadPermission();
        Permissions_1.rbacPermissions.verifyFileSearchPermission();
        Permissions_1.rbacPermissions.verifyFileDeletePermission();
    };
    return PermissionsGroup;
}());
exports.PermissionsGroup = PermissionsGroup;
//# sourceMappingURL=PermissionsGroup.js.map